<template>
  <span @dragend="drop" :dropzone="moveable">
    <div
      @dragenter="over(true)"
      class="dragSlot"
      :class="{
        dragActive: !dragged && draggedOver && moveable,
        dragExpand: !dragged && draggedOver && moveable && overPos == 'back',
      }"
    ></div>
    <v-timeline-item
      :id="step.id"
      class="timelineItem"
      :color="deactivated ? 'grey' : stepColor || 'blue lighten-3'"
      :icon="'mdi-' + stepIcon"
      medium
      :class="{ op: dragged }"
    >
      <!-- <Tooltip
        content="Edit Step"
        icon="pencil-outline"
        color="blue"
        top
        :active="!active"
      > -->
      <v-card
        :color="deactivated ? 'grey' : result ? stepBorderColor : stepColor"
        class="step"
        :elevation="active ? 4 : 0"
        :max-width="stepWidth"
        :class="{
          'not-active': true,
          op: dragged || inactive,
        }"
        :draggable="moveable"
        @dragstart="drag"
        @dragout="out"
        @dragenter="over(true)"
        @mouseenter="prev = true"
        @mouseleave="prev = false"
        :id="result ? result.id : step.id"
      >
        <v-btn
          v-show="step.loop && step.loop > 1"
          class="loop text-capitalize"
          :color="deactivated ? 'grey' : result ? stepBorderColor : 'purple'"
          outlined
          small
        >
          <Tooltip
            content="Step's loop counter"
            icon="sync"
            color="light-blue"
            top
          >
            <span class="">Loop for x{{ step.loop }}</span>
          </Tooltip>
        </v-btn>
        <v-card-title class="pa-2" :class="{ pointer: !isRoutine }">
          <v-row>
            <v-col v-if="isRoutine" cols="auto" class="pr-1">
              <v-icon
                class="lighten-5 iconWrap mt-n2 ml-n1"
                :class="deactivated ? 'grey' : stepColor"
                :color="deactivated ? 'grey' : stepColor"
              >
                mdi-{{ stepIcon }}
              </v-icon>
            </v-col>
            <v-col v-else cols="auto" class="pr-1" @click="editTest">
              <v-icon
                class="lighten-5 iconWrap mt-n2 ml-n1"
                :class="deactivated ? 'grey' : actionColor"
                :color="deactivated ? 'grey' : actionColor"
              >
                mdi-{{ actionIcon }}
              </v-icon>
            </v-col>
            <v-col
              cols="auto"
              class="pl-0 pr-1 pt-4 font-italic font-weight-bold text-center text-uppercase text-caption"
              :class="{
                'purple--text': !deactivated,
                'grey--text': deactivated,
              }"
              dark
              v-if="
                ['get', 'post', 'put', 'delete', 'patch'].indexOf(
                  actionMethod
                ) >= 0
              "
              >[{{ actionMethod }}]
            </v-col>
            <v-col
              v-if="!active"
              class="text-truncate pl-0 pt-2"
              :class="{
                'grey--text': deactivated,
              }"
              @click="editTest"
            >
              <div class="text-truncate">
                <strong :title="step.name">{{ step.name }}</strong>
              </div>
            </v-col>
            <v-col v-else class="text-truncate pt-4" cols="auto">
              <v-combobox
                clearable
                v-model="step.name"
                label="Step Name"
                :items="steps"
                placeholder="Do Stuff"
                hide-details
                dense
                @keyup="fetchSteps"
                @change="loadStep"
                :draggable="false"
                :disabled="deactivated"
              >
              </v-combobox>
            </v-col>
            <v-spacer v-if="active" @click="editTest"> </v-spacer>
            <v-col v-if="isRoutine" cols="auto" class="px-2 pt-1 mb-3 pointer">
              <Tooltip content="Edit Routine" color="teal" top>
                <v-btn
                  :color="deactivated ? 'grey' : 'teal'"
                  x-small
                  @click="routeToRoutine"
                  icon
                >
                  <v-icon> mdi-pencil-lock </v-icon>
                </v-btn>
              </Tooltip>
            </v-col>
            <v-col v-if="active" cols="2" class="px-2 pt-1 mb-3 pointer">
              <Tooltip
                content="Step's loop counter"
                color="purple"
                icon="sync"
                top
              >
                <v-text-field
                  hide-details
                  dense
                  type="number"
                  min="1"
                  prepend-icon="mdi-sync"
                  color="purple"
                  v-model="step.loop"
                >
                  <v-icon
                    slot="prepend"
                    :color="step.loop > 1 ? 'purple' : ''"
                    size="20"
                    >mdi-sync</v-icon
                  >
                </v-text-field>
              </Tooltip>
            </v-col>
            <v-col v-if="isRoutine" cols="auto" class="px-2 pt-1 mb-3 pointer">
              <Tooltip
                content="Clone Routine steps"
                color="indigo"
                top
                :active="false"
              >
                <v-icon small disabled :color="deactivated ? 'grey' : 'indigo'">
                  mdi-lock-open-alert
                </v-icon>
              </Tooltip>
            </v-col>
            <v-col
              cols="auto"
              v-else
              class="px-2 pt-1 mb-3 pointer"
              @click="editTest"
            >
              <Tooltip
                :content="active ? 'Collapse' : 'Expand'"
                color="info"
                top
              >
                <v-icon small :color="deactivated ? 'grey' : 'blue'">
                  mdi-arrow-{{ active ? "collapse" : "expand" }}
                </v-icon>
              </Tooltip>
            </v-col>
            <v-col cols="auto" class="px-2 pt-1">
              <Tooltip
                :content="(deactivated ? 'Activate' : 'Deactivate') + ' Step'"
                :color="deactivated ? 'green' : 'red'"
                top
                :active="!deactivated"
              >
                <v-btn
                  :color="deactivated ? 'grey' : 'green'"
                  x-small
                  icon
                  :disabled="inactive"
                  @click="activateToggle"
                >
                  <v-icon>
                    mdi-toggle-switch{{ deactivated ? "-off-outline" : "" }}
                  </v-icon>
                </v-btn>
              </Tooltip>
            </v-col>
            <span class="indicator" v-if="debuggerRunning || result">
              <v-icon
                :color="deactivated ? 'grey' : stepBorderColor"
                v-if="result"
                >mdi-thumb-{{ this.resultStatus ? "up" : "down" }}</v-icon
              >
              <ActionsLoader v-if="!result && !deactivated" />
            </span>
            <v-col cols="auto" class="pointer" v-if="!active && result">
              <v-scroll-x-transition>
                <v-card
                  class="my-3 mr-4 pa-0 prev"
                  elevation="4"
                  rounded
                  v-if="prev && result && result.image"
                  @click="openImage(result.image)"
                >
                  <div class="fill-height block">
                    <v-icon small color="white">mdi-arrow-expand</v-icon>
                  </div>
                  <v-img eager cover :src="result.image"> </v-img>
                </v-card>
              </v-scroll-x-transition>
              <v-row>
                <v-col class="pb-0" cols="auto" @click="editTest">
                  <v-row class="ma-0">
                    <v-chip
                      small
                      class="mx-1 pointer fw"
                      v-if="'duration' in result && result.duration >= 0"
                      :disabled="result.inactive"
                      :color="result.inactive ? null : 'info'"
                    >
                      <v-icon class="mx-1" small fab>mdi-timer-outline</v-icon>
                      <strong
                        :class="!result.inactive ? null : ' text--white'"
                        >{{
                          timeFormatter(routineParent ? 0 : result.duration)
                        }}</strong
                      >
                    </v-chip>
                  </v-row>
                  <v-row class="mx-0 my-1">
                    <v-chip
                      small
                      class="mx-1 pointer fw text--lighten-1"
                      v-if="result.success"
                      :disabled="result.inactive"
                      :color="result.inactive ? null : 'success'"
                    >
                      <v-icon class="mx-1" small fab> mdi-thumb-up </v-icon>
                      <strong> Passed </strong>
                    </v-chip>

                    <v-chip
                      v-if="!result.success && !result.inactive"
                      color="red"
                      class="mx-1 pointer fw"
                      small
                      dark
                    >
                      <v-icon label="Failed" class="mx-1" small fab>
                        mdi-thumb-down
                      </v-icon>
                      <strong> Failed</strong>
                    </v-chip>
                  </v-row>
                </v-col>
                <v-col cols="auto py-0" v-if="result.inactive">
                  <v-icon color="grey" small>mdi-connection</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="px-1 py-0">
          <v-row class="no-gutters relative">
            <v-col>
              <p v-if="step.description && !active && !deactivated">
                {{ step.description }}
              </p>
              <StepView
                v-if="active && !isRoutine"
                :disabled="deactivated || routineParent"
                v-model="step"
              />
            </v-col>
            <v-scroll-x-transition>
              <v-card
                :color="result.inactive ? 'grey' : stepBorderColor"
                class="step prevRes"
                v-if="active && prev && result"
              >
                <v-card-text class="py-0">
                  <p
                    v-if="result.description && !active"
                    class="ma-0 grey--text"
                  >
                    {{ result.description }}
                  </p>
                  <v-row v-if="active" class="grey my-1 lighten-5">
                    <v-col v-if="!result.inactive" class="scrollable h25 pa-0">
                      <v-list disabled class="trns">
                        <v-list-item dense v-if="result.result && result.image">
                          <v-list-item-content>
                            <p
                              class="blue--text mb-0"
                              v-html="result.result"
                            ></p>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense>
                          <v-list-item-content>
                            <v-list-item-title class="body-2">
                              <strong>
                                <v-icon small>mdi-list-status</v-icon> Status:
                              </strong>
                              <strong
                                :class="
                                  (result.success ? 'success' : 'red') +
                                  '--text'
                                "
                              >
                                <v-icon
                                  small
                                  :class="{ 'mb-1': result.success }"
                                  :color="result.success ? 'success' : 'red'"
                                >
                                  mdi-thumb-{{ result.success ? "up" : "down" }}
                                </v-icon>
                                {{ result.success ? "Passed" : "Failed" }}
                              </strong>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense v-if="step.loop > 1">
                          <v-list-item-content>
                            <v-list-item-title class="body-2">
                              <strong>
                                <v-icon small>mdi-sync</v-icon> Loop count:
                              </strong>
                              <strong
                                :class="
                                  (result.loop == step.loop
                                    ? 'success'
                                    : 'red') + '--text'
                                "
                              >
                                {{ result.loop }}/{{ step.loop }}
                              </strong>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense v-if="result.description">
                          <v-list-item-content>
                            <v-list-item-title class="body-2">
                              <strong>
                                <v-icon small>mdi-text</v-icon> Description:
                              </strong>
                            </v-list-item-title>
                            <p class="ml-3 grey--text">
                              {{ result.description }}
                            </p>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="'duration' in result && result.duration >= 0"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="body-2">
                              <strong>
                                <v-icon small>mdi-timer-outline</v-icon>
                                Duration:
                              </strong>
                              {{
                                timeFormatter(result.duration)
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense v-if="result.device">
                          <v-list-item-content>
                            <v-list-item-title class="body-2">
                              <strong>
                                <v-icon small>mdi-devices</v-icon> Device:
                              </strong>
                              {{ result.device }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense v-if="result.env">
                          <v-list-item-content>
                            <v-list-item-title class="body-2">
                              <strong>
                                <v-icon small>mdi-variable</v-icon> Env:
                              </strong>
                              <v-chip-group active-class="primary--text" column>
                                <v-chip
                                  color="blue"
                                  dark
                                  small
                                  v-for="env in result.env"
                                  :key="env.name"
                                  :title="env.value"
                                >
                                  <Tooltip
                                    :content="env.value"
                                    color="info"
                                    top
                                  >
                                    <strong> {{ env.name }}</strong>
                                  </Tooltip>
                                </v-chip>
                              </v-chip-group>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-list class="trns">
                        <v-list-item dense v-if="result.logs">
                          <v-list-item-content>
                            <v-list-item-title class="body-2">
                              <strong>
                                <v-icon small>mdi-clipboard-list</v-icon>
                                Logs:
                              </strong>

                              <v-btn
                                @click="openResponse(result.logs, 'log')"
                                color="blue"
                                centered
                                x-small
                                dark
                              >
                                <v-icon small>mdi-magnify</v-icon>
                                View Logs
                              </v-btn>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="5" v-if="result.image" class="thumbnail pa-0">
                      <v-img
                        @click="openImage(result.image)"
                        eager
                        :lazy-src="result.image"
                        :src="result.image"
                      >
                        <div class="fill-height block">
                          <v-icon color="white">mdi-arrow-expand</v-icon>
                        </div>
                      </v-img>
                    </v-col>
                    <v-col
                      cols="5"
                      v-if="result.type === 0 && !result.inactive"
                    >
                      <v-row class="justify-center">
                        <v-col cols="auto">
                          <v-btn
                            @click="openResponse(result.result)"
                            color="blue"
                            centered
                            dark
                          >
                            <v-icon small>mdi-magnify</v-icon>
                            View Response
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      class="h25"
                      v-if="
                        (result.type === 1 && !result.image) || result.inactive
                      "
                    >
                      <p v-html="result.result"></p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-scroll-x-transition>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-1 pointer" @click="editTest">
          <v-icon
            class="mr-2"
            v-if="step.waitFor && Object.keys(step.waitFor).length"
            small
            :color="step.inactive ? 'grey' : 'teal'"
          >
            mdi-sleep
          </v-icon>
          <!-- <v-icon
            class="mr-2"
            v-if="step.waitAfter && Object.keys(step.waitAfter).length"
            small
            :color="step.inactive ? 'grey' : 'teal'"
          >
            mdi-sleep-off
          </v-icon> -->
          <v-icon
            class="mr-2"
            v-if="step.env && Object.keys(step.env).length"
            small
            :color="step.inactive ? 'grey' : 'teal'"
            title="Environment Variable Active"
          >
            mdi-variable
          </v-icon>
        </v-card-actions>
        <v-card
          v-if="!routineParent"
          class="actions"
          elevation="0"
          color="transparent"
        >
          <Tooltip content="Duplicate step" color="green" left>
            <v-btn
              class="mx-1"
              @click="duplicate()"
              color="green"
              x-small
              fab
              elevation="4"
              dark
              label="Duplicate Step"
            >
              <v-icon small>mdi-content-duplicate</v-icon>
            </v-btn>
          </Tooltip>
          <Tooltip content="Add UI child" top>
            <v-btn
              v-if="allowChildren"
              class="mx-1"
              @click="addStep(1)"
              color="blue"
              x-small
              fab
              elevation="4"
              dark
              label="UI Step"
            >
              <v-icon small>mdi-flask-plus-outline</v-icon>
            </v-btn>
          </Tooltip>
          <Tooltip content="Add API child" color="purple" top>
            <v-btn
              class="mx-1"
              v-if="allowChildren"
              color="purple"
              @click="addStep(0)"
              x-small
              elevation="4"
              dark
              fab
              label="API Step"
            >
              <v-icon>mdi-server-plus</v-icon>
            </v-btn>
          </Tooltip>
          <Tooltip content="Add Routine child" color="indigo" top>
            <v-btn
              class="mx-1 mr-5"
              v-if="allowChildren"
              color="indigo"
              @click="openImportDialog"
              x-small
              elevation="4"
              dark
              fab
              label="Routine Step"
            >
              <v-icon>mdi-cog-clockwise</v-icon>
            </v-btn>
          </Tooltip>
          <Tooltip content="Delete Step" color="error" top>
            <v-btn
              class="mx-1 ml-5"
              color="error"
              @click="deleteStep"
              x-small
              elevation="4"
              dark
              fab
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </Tooltip>
          <Tooltip
            v-if="step.children && step.children.length && !isRoutine"
            content="Delete All Children"
            color="error darken-1"
            right
          >
            <v-btn
              class="mx-1"
              v-if="step.children && step.children.length && !isRoutine"
              color="error darken-1"
              @click="deleteChildren"
              x-small
              elevation="4"
              dark
              fab
            >
              <v-icon>mdi-test-tube-off</v-icon>
            </v-btn>
          </Tooltip>
        </v-card>
      </v-card>
      <!-- </Tooltip> -->
      <v-card
        :class="expand ? 'collapse' : 'expand'"
        v-if="step.children && step.children.length"
        elevation="0"
        color="transparent"
      >
        <Tooltip
          :content="
            debuggerRunning
              ? 'Collapse disabled while debugging'
              : expand
              ? 'Collapse children'
              : 'Expand children'
          "
          :color="expand ? 'accent' : 'success'"
          bottom
          left
        >
          <v-btn
            @click="expand = !expand"
            small
            fab
            text
            :disabled="debuggerRunning"
          >
            <v-icon :color="expand ? 'accent' : 'success'">
              mdi-{{ expand ? "collapse" : "expand" }}-all
            </v-icon>
          </v-btn>
        </Tooltip>
      </v-card>

      <div
        v-if="!step.children || !step.children.length"
        @dragenter="over(true, true)"
        class="dragSlot"
        :class="{
          dragActive: !dragged && draggedOver,
          dragExpand: !dragged && draggedOver && overPos == 'child',
        }"
      ></div>
      <v-timeline
        class="section"
        v-if="step.children && step.children.length && expand && !dragged"
        align-top
        dense
      >
        <time-line-test
          v-for="(t, i) in step.children"
          :key="i"
          :test="t"
          :pos="[...pos, i]"
          dense
          :inactive="deactivated || isRoutine"
          :routineParent="isRoutine || routineParent"
          :last="i === step.children.length - 1"
          @duplicate="addChild"
        />
        <v-card
          class="actions2"
          elevation="0"
          v-if="!routineParent"
          color="transparent"
        >
          <Tooltip content="Add UI sibling Step" top>
            <v-btn
              class="mx-1"
              @click="addStep(1)"
              color="blue"
              x-small
              fab
              elevation="4"
              dark
              label="UI Step"
            >
              <v-icon small>mdi-flask-plus-outline</v-icon>
            </v-btn>
          </Tooltip>
          <Tooltip content="Add API sibling Step" color="purple" top>
            <v-btn
              class="mx-1"
              color="purple"
              @click="addStep(0)"
              x-small
              elevation="4"
              dark
              fab
              label="API Step"
            >
              <v-icon>mdi-server-plus</v-icon>
            </v-btn>
          </Tooltip>
          <Tooltip content="Add Routine sibling Step" color="indigo" top>
            <v-btn
              class="mx-1"
              v-if="allowChildren"
              color="indigo"
              @click="openImportDialog"
              x-small
              elevation="4"
              dark
              fab
              label="Routine Step"
            >
              <v-icon>mdi-cog-clockwise</v-icon>
            </v-btn>
          </Tooltip>
        </v-card>
      </v-timeline>
      <v-card
        v-if="step.children && step.children.length && !expand"
        elevation="0"
        class="pa-2 font-weight-bold"
        @click="expand = !expand"
        :disabled="debuggerRunning"
      >
        + {{ step.children.length }}
        <v-icon size="20" class="mb-1" :color="stepColor">
          mdi-{{ stepIcon }}
        </v-icon>
        {{ isRoutine ? "Routine " : null }}
        {{ step.children.length > 1 ? "Children" : "Child" }}
      </v-card>
    </v-timeline-item>
    <div
      v-if="lastStep"
      @dragenter="over(false)"
      class="dragSlot"
      :class="{
        dragActive: !dragged && draggedOver,
        dragExpand: !dragged && draggedOver && overPos == 'end',
      }"
    ></div>
  </span>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

import {
  actionIcon,
  actionColor,
  statusFailColor,
  statusSuccessColor,
  timeFormatter,
  stepColor,
  stepIcon,
  cloneObj,
  reId,
  scrollToID,
} from "../utils";
import Tooltip from "@/components/Tooltip.vue";
import { Plan, StepType, SelectItem, Step, ResultData } from "../types";
import { DefaultStep } from "../defaults";
import StepView from "./Step.vue";
import { v4 } from "uuid";
import ActionsLoader from "./listTable/actions/ActionsLoader.vue";

export default Vue.extend({
  components: { Tooltip, StepView, ActionsLoader },
  name: "time-line-test",

  data() {
    return {
      position: [],
      expand: true,
      prev: false,
      overPos: "",
      timer: 0,
      // deactivated: false
    };
  },
  props: {
    test: VueTypes.any,
    pos: VueTypes.any,
    draggable: VueTypes.bool.def(true),
    last: VueTypes.bool.def(false),
    inactive: VueTypes.bool.def(false),
    routineParent: VueTypes.bool.def(false),
  },
  methods: {
    timeFormatter,
    addStep(type = StepType.UI) {
      this.resetDebugger();
      const step: Step = cloneObj(DefaultStep);
      step.id = v4();
      step.type = type;
      step.action = {
        method: type ? "click" : "get",
        selector: "",
        type: type ? "user" : "api",
      };
      this.addChild(step);
    },
    addChild(step: Step, selectStep = true) {
      this.step.children.push(step);
      if (selectStep) {
        this.$store.commit("Plans/setPlanCurrentStep", step.id);
      }
      setTimeout(() => {
        scrollToID(step.id);
      }, 100);
    },
    openImportDialog() {
      this.$store.commit("setImportDialog", {
        active: true,
        items: this.routines,
        title: "Select Test Routine to import",
        action: this.addRoutine,
      });
    },
    async addRoutine(item: SelectItem) {
      this.resetDebugger();
      const routine: Plan = await this.$store.dispatch(
        "Plans/fetchPlan",
        item.value
      );
      const step: Step = cloneObj(DefaultStep);
      step.id = v4();
      step.type = StepType.ROUTINE;
      step.name = routine.name;
      step.ref = routine._id;
      step.children = routine.steps;
      this.addChild(step, false);
    },
    editTest() {
      if (this.isRoutine) {
        return;
      }
      // this.expand = true;
      if (this.active) {
        this.$store.commit("Plans/setPlanCurrentStep");
        this.$store.commit("Results/setCurrentResultView");
      } else {
        this.$store.commit("Results/setCurrentResultView");
        this.$store.commit("Plans/setPlanCurrentStep", this.step.id);
      }
      // this.$store.commit("Plans/setPlanDisplayDebugger", false);
      // this.$store.commit("Plans/setPlanCurrentDebugger");
    },
    duplicate() {
      this.$store.commit("Plans/setPlanDisplayDebugger", false);
      this.$store.commit("Plans/setPlanCurrentDebugger");
      this.$store.commit("Plans/setPlanCurrentStep");
      const step = reId(cloneObj(this.step));

      this.$emit("duplicate", step);
    },
    deleteStep() {
      this.$store.commit("Plans/setPlanDisplayDebugger", false);
      this.$store.commit("Plans/setPlanCurrentDebugger");
      const title = `Delete "${this.step.name}" Step`;
      const content = `Are you sure you with to delete <strong>"${
        this.step.name
      }"</strong>
      ${
        this.step?.children && this.step.children.length
          ? " and it's <strong>children</strong>"
          : ""
      }?`;
      const dialog = {
        active: true,
        content,
        action: this.deleteSelectedStep,
        title,
      };
      this.$store.commit("setDeleteDialog", dialog);
    },
    deleteSelectedStep() {
      this.$store.commit("Plans/deleteStep", this.step.id);
    },
    deleteChildren() {
      this.$store.commit("Plans/setPlanDisplayDebugger", false);
      this.$store.commit("Plans/setPlanCurrentDebugger");
      const title = `Delete "${this.step.name}" Children`;
      const content = `Are you sure you with to delete <strong>"${this.step.name}'s" children</strong>?`;
      const dialog = {
        active: true,
        content,
        action: this.deleteSelectedChildren,
        title,
      };
      this.$store.commit("setDeleteDialog", dialog);
    },
    deleteSelectedChildren() {
      this.step.children = [];
    },
    isLast(i: number) {
      return i == this.step.children.length - 1;
    },
    fetchSteps(e) {
      const val = e.target.value;
      this.step.name = val;
      // console.log("input", val);
      // this.$store.commit("Plans/checkCurrentPlanChange");
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = 0;
      }
      this.timer = setTimeout(() => {
        this.$store.dispatch("Plans/fetchSteps", val);
      }, 500);
    },
    loadStep(step: any) {
      // console.log(step);
      if (step?.name) {
        const { action, group, hash, name, type } = step;
        this.step.action = action;
        this.step.group = group;
        this.step.hash = hash;
        this.step.name = name;
        this.step.type = type;
      }
    },
    // activateRecursive(step: Step, status: boolean) {
    //   if (status !== step.inactive) {
    //     step.inactive = status;
    //     if (step.children.length) {
    //       for (const child of step.children) {
    //         this.activateRecursive(child, status);
    //       }
    //     }
    //   }
    // },
    activateToggle() {
      // this.deactivated = !this.deactivated;
      this.step.inactive = !this.step.inactive;
      // this.activateRecursive(this.step, this.deactivated);
      if (this.active) {
        this.$store.commit("Plans/setPlanCurrentStep");
      }
    },
    expandToggle() {
      this.expand = !this.expand;
    },
    drag() {
      if (this.active) {
        return;
      }
      this.expand = false;
      this.$store.commit("Plans/setCurrentDragStep", {
        step: { ...this.step },
        pos: this.pos,
      });
      // console.log("drag", this.currentDragStep?.step.id, this.step.id);
    },
    over(before = true, child = false) {
      if (!this.dragged && this.currentDragStep && !this.deactivated) {
        if (before) {
          this.overPos = "back";
        } else {
          this.overPos = "end";
        }
        if (child) {
          this.overPos = "child";
        }
        this.expand = true;
        // console.log("over", this.step.id, before);
        this.$store.commit("Plans/setCurrentDragOverStep", {
          id: this.step.id,
          pos: this.pos,
          before,
          child,
        });
      }
    },
    out() {
      this.$store.commit("Plans/setCurrentDragOverStep");
    },
    drop() {
      if (
        this.currentDragStep &&
        this.$store.getters["Plans/getCurrentDragOverStep"]
      ) {
        // console.log(
        //   "drop",
        //   this.$store.getters["Plans/getCurrentDragOverStep"]?.id,
        //   this.step.id
        // );
        this.resetDebugger();
        this.$store.commit("Plans/setDragAndDrop");
      }
      this.$store.commit("Plans/setCurrentDragStep");
      this.expand = true;
    },
    resetDebugger() {
      this.$store.commit("Plans/setPlanDisplayDebugger", false);
      this.$store.commit("Plans/setPlanCurrentStep");
      this.$store.commit("Plans/setPlanCurrentDebugger");
      this.$store.commit("Results/setCurrentResultView");
    },
    routeToRoutine() {
      this.$router.replace(this.routineLink);
      this.$router.go();
    },
    openImage(src: string) {
      const { innerHeight, innerWidth } = window;
      const width = Math.min(this.imgMeta.width, innerWidth * 0.8);
      const res = width / this.imgMeta.width;
      const height = Math.min(this.imgMeta.height * res, innerHeight * 0.9);
      this.$store.commit("setSlidesOptions", {
        height,
        width,
      });
      this.$store.commit("setSlides", [src]);
    },
    openResponse(resp: any, type = "html") {
      this.$store.commit("setResponse", resp);
      this.$store.commit("setResponseOptions", { type });
    },
  },
  computed: {
    step: {
      get() {
        return this.test;
      },
      set(val: unknown) {
        // const step = updateObj()
        console.log(val);

        // this.$emit("input", val);
      },
    },
    debuggerRunning(): boolean {
      return this.$store.getters["Plans/getDebuggerRunning"];
    },
    result(): ResultData {
      const result = this.$store.getters["Plans/getPlanCurrentDebuggerResult"](
        this.step.id
      );
      return result;
    },
    stepBorderColor(): string {
      return this.resultStatus ? statusSuccessColor : statusFailColor;
    },
    stepWidth(): string {
      return this.active ? "600px" : "500px";
    },
    resultStatus(): boolean {
      return this.result?.success;
    },
    imgMeta(): any {
      const meta: any = {};
      if (this.result?.image) {
        var img = new Image();
        img.src = this.result?.image;
        const { height, width } = img;
        meta.height = height;
        meta.width = width;
      }
      return meta;
    },
    steps(): Step[] {
      return this.$store.getters["Plans/getSteps"];
    },
    active(): boolean {
      const activeStep = this.$store.getters["Plans/getActiveStep"](
        this.step.id
      );
      const activeRes = this.$store.getters["Results/getActiveResultByTestID"](
        this.step.id
      );
      return activeStep || activeRes;
    },
    moveable() {
      return this.draggable && !this.active;
    },
    dragged(): boolean {
      return this.step.id === this.currentDragStep?.step?.id;
    },
    currentDragStep(): any | null {
      return this.$store.getters["Plans/getCurrentDragStep"];
    },
    currentDragStepOver(): any | null {
      return this.$store.getters["Plans/getCurrentDragOverStep"];
    },
    draggedOver(): boolean {
      return this.currentDragStepOver?.id === this.step.id;
    },
    deactivated(): boolean {
      return this.inactive || this.step.inactive;
    },
    actionType(): string {
      return this.step?.action?.type;
    },
    actionMethod(): string {
      return this.step?.action?.method;
    },
    actionColor(): string {
      return actionColor[this.actionType];
    },
    actionIcon(): string {
      return actionIcon[this.actionMethod];
    },
    stepType(): number {
      return this.step?.type;
    },
    stepColor(): string {
      return stepColor[this.stepType];
    },
    stepIcon(): string {
      return stepIcon[this.stepType];
    },
    lastStep(): boolean {
      return this.last;
    },
    allowChildren(): boolean {
      return this.pos?.length < 4 && !this.isRoutine;
    },
    routines(): SelectItem[] {
      return this.$store.getters["Plans/getRoutines"];
    },
    isRoutine(): boolean {
      return this.stepType === StepType.ROUTINE;
    },
    routineLink(): string {
      return `/routines/edit/${this.step.ref}#routine`;
    },
    importDialog: {
      get(): boolean {
        return this.$store.getters.getImportDialogActive;
      },
      set(val: boolean) {
        this.$store.commit("setImportDialogActive", val);
      },
    },
    lastResult(): string | undefined {
      return this.$store.getters["Plans/getLastResult"];
    },
  },
  watch: {
    debuggerRunning(running: boolean) {
      if (running) {
        this.expand = true;
      }
    },
    lastResult(lastId: string | undefined) {
      setTimeout(() => {
        if (lastId) {
          scrollToID(lastId);
        }
      }, 50);
    },
  },
  mounted() {
    if (this.isRoutine) {
      this.expand = false;
    }
  },
  updated() {
    this.$store.commit("Plans/checkCurrentPlanChange");
  },
});
</script>
<style scoped>
.activate {
  position: absolute;
  z-index: 200;
  right: 10px;
  top: 0;
}
.actions {
  position: absolute;
  z-index: 200;
  right: 10px;
  bottom: -15px;
  display: none;
  opacity: 0;
  transition: "opacity" 2.5s ease;
}
.actions2 {
  position: absolute;
  z-index: 200;
  left: -12px;
  bottom: -10px;
  display: none;
  opacity: 0;
  transition: "opacity" 2.5s ease;
}
.expand {
  position: absolute;
  z-index: 200;
  left: -45px;
}
.collapse {
  position: absolute;
  z-index: 200;
  left: -45px;
}
.expand::before,
.collapse::before {
  border: 0 !important;
}
.step {
  border: 2px solid;
  background-color: #fff !important;
  box-shadow: none;
  min-height: 80px;
  min-width: 350px;
}
.actions:hover,
.actions2:hover,
.section:hover > .actions2,
.section:hover > .expand,
.step:hover > .actions,
.step:hover > .expand {
  opacity: 1;
  display: block;
}
.link {
  cursor: pointer;
}
.step {
  border: 2px solid;
}
.not-active {
  background-color: transparent !important;
}
.op,
.dragSlot {
  opacity: 0.3;
}
.h0 {
  height: 0;
}
.dragSlot {
  height: 0px;
  padding: 0px;
  width: auto;
  max-width: 450px;
  display: none;
  opacity: 0;
  margin-left: 100px;
  margin-bottom: 0px;
  margin-top: 0px;
  border: 2px dashed;
  border-color: rgba(128, 128, 128, 0.792);
  transition: 0.2s all ease;
}
.dragActive {
  opacity: 0.6;
  margin-bottom: 10px;
  margin-top: 10px;
  display: block;
  height: 25px;
}
.dragExpand {
  height: 80px;
  background-color: rgba(173, 216, 230, 0.409);
  border-color: lightblue !important;
}
.pointer {
  cursor: pointer;
}
.refChild {
  min-height: 50px;
  height: 50px;
}
.thumbnail,
.prev {
  border: 2px solid rgba(128, 128, 128, 0.43);
  overflow: hidden;
  height: auto;
  max-height: 220px;
  border-radius: 5px;
}
.thumb {
  overflow-y: hidden;
  height: 60px;
}
.prevRes {
  position: absolute;
  top: -40px;
  left: 98%;
  z-index: 150;
}
.prev {
  max-height: 150px;
  position: absolute;
  top: -25px;
  right: -250px;
  width: 250px;
  z-index: 150;
  box-shadow: -5px -5px 0 20px rgba(0, 0, 0, 0.6);
}
.thumbnail .v-image,
.thumb {
  height: 100%;
  position: relative;
  /* border: 2px solid rgba(128, 128, 128, 0.43);
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.282); */
}
.thumbnail .block,
.prev .block {
  opacity: 0;
  background: rgba(0, 0, 0, 0.368);
  cursor: pointer;
  transition: opacity 0.5s ease;
}
.prev .block {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 100;
}
.thumbnail .block:hover,
.prev .block:hover,
.thumb .block:hover {
  opacity: 1;
}
.thumbnail .block .v-icon,
.prev .block .v-icon,
.thumb .block .v-icon {
  position: absolute;
  top: min(100px, 45%);
  right: 0;
  left: 0;
}
.prev .block .v-icon {
  top: min(75px, 45%);
}
.indicator,
.loop {
  position: absolute;
  right: -10%;
  top: 25%;
}
.loop {
  background-color: #fff;
  color: "light-blue" !important;
  right: -90px;
  top: -20px;
}
.loopCountWrap {
  position: relative;
}
.loopCounter {
  position: absolute;
  left: 0;
  right: 0;
}
</style>
